(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdCompListAccsService", ['$ihttp', function ($ihttp) {
        let service = {
            listComponents: function (parms) {
                return $ihttp.post({
                    method: 183,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
